import React, { ComponentType } from 'react';
import {
  InputAttributes,
  NumericFormat,
  NumericFormatProps,
} from 'react-number-format';

import { Input } from '@ast/magma/components/input';

import { client } from '@app/core/apolloClient';

import { RoutingNumberType } from '@app/queryTyping';

import {
  GetBankInfoByRoutingNumberQuery,
  GetBankInfoByRoutingNumberDocument,
  GetBankInfoByRoutingNumberQueryVariables,
} from './queryTyping/get-bank-info-by-routing-number';

export const ROUTING_NUMBER_LENGTH = 9;
export const ROUTING_NUMBER_PATTERN = /^[0-9]{9}$/;

export type RoutingNumberFieldProps = NumericFormatProps & {label?: string | null};
export type RoutingNumberFieldRef = NumericFormatProps;

export interface BankNameValidationFactoryParameters {
  routingNumberType: RoutingNumberType;
  allowOwnFi: boolean;
}
export const bankNameValidationFactory = ({ routingNumberType, allowOwnFi }: BankNameValidationFactoryParameters) => (
  async (routingNumber: string) => {
    const { data } = await client.query<GetBankInfoByRoutingNumberQuery, GetBankInfoByRoutingNumberQueryVariables>({
      query: GetBankInfoByRoutingNumberDocument,
      variables: { routingNumber, routingNumberType, allowOwnFi },
    });

    return (
      Boolean(data?.bankInfoByRoutingNumber.bankInfo)
        || (
          Array.isArray(data?.bankInfoByRoutingNumber.validationResult?.errorMessages)
          && data?.bankInfoByRoutingNumber.validationResult?.errorMessages[0]
        )
    );
  }
);

export const bankNameValidation = bankNameValidationFactory({
  routingNumberType: RoutingNumberType.ACH,
  allowOwnFi: false,
});

export const wireBankNameValidation = bankNameValidationFactory({
  routingNumberType: RoutingNumberType.WIRE,
  allowOwnFi: false,
});

export const achwireBankNameValidation = bankNameValidationFactory({
  routingNumberType: RoutingNumberType.ACHWIRE,
  allowOwnFi: false,
});

export const RoutingNumberField = React.forwardRef((
  props: RoutingNumberFieldProps,
  ref: React.Ref<RoutingNumberFieldRef>,
) => (
  <NumericFormat
    {...props}
    allowLeadingZeros
    allowNegative={false}
    autoComplete="off"
    customInput={Input as ComponentType<InputAttributes> | undefined}
    decimalScale={0}
    inputMode="numeric"
    getInputRef={ref}
    maxLength={ROUTING_NUMBER_LENGTH}
  />
));
